import React from 'react';
import { Container, Button, Image, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Landing = () => {
  return (
    <Container className="d-flex flex-column justify-content-center align-items-center min-vh-100">
      <Row className="align-items-center justify-content-center mb-4">
        <Col xs={12} md={6} className="text-md-left">
          <h1 className="display-1 fw-bold mb-4">Investing made simple</h1>
          <p className="lead mb-4">
            With over 100 million data points, we offer market-beating insights and portfolio analysis.
          </p>
          <Button as={Link} to="/about" variant="primary" size="lg">Learn More</Button>
        </Col>
        <Col xs={12} md={4} className="text-center mb-3 mb-md-0">
          <Image src={process.env.PUBLIC_URL + '/test.png'} alt="Deepstone Logo" fluid className='hide-on-mobile' />
        </Col>
      </Row>
    </Container>
  );
};

export default Landing;
